import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import { Process, ProcessListTable } from '../types';
import { ColumnTable, Icon } from '@octano/global-ui';

interface UseProcessColumnsProps {
  toggleEditProcess: (process?: Process) => void;
}

export function useProcessColumns({
  toggleEditProcess,
}: UseProcessColumnsProps) {
  const { t } = useTranslation(TranslationsKeys.CONFIGURATION_ACADEMIC_OFFER);

  const texts = useMemo(() => {
    return {
      admissionProcess: t('processList.columns.admissionProcess'),
      hasMultiTuition: t('processList.columns.hasMultiTuition'),
      firstExpirationRule: t('processList.columns.firstExpirationRule'),
      edit: t('processList.columns.edit'),
    };
  }, [t]);

  const columns: ColumnTable<ProcessListTable>[] = useMemo(() => {
    return [
      {
        columnName: 'name',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: texts.admissionProcess,
      },
      {
        columnName: 'isMultiTuition',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: texts.hasMultiTuition,
        cellFormat: ({ row }) => {
          return row.isMultiTuition ? 'Si' : 'No';
        },
      },
      {
        columnName: 'firstInstallmentRule',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: texts.firstExpirationRule,
        cellFormat: ({ row }) => {
          return row.firstInstallmentRule ? 'Definido' : 'Por definir';
        },
      },
      {
        columnName: 'edit',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: texts.edit,
        cellFormat: ({ row }) => {
          return (
            <span onClick={() => toggleEditProcess(row as Process)}>
              <Icon name="edit" color="primary" className="cursor-pointer" />
            </span>
          );
        },
      },
    ];
  }, [texts, toggleEditProcess]);

  return columns;
}
